import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/OptionsMenu/options-menu';
import { css } from '@patternfly/react-styles';
import { Divider } from '../Divider';
export var OptionsMenuItemGroup = function OptionsMenuItemGroup(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      _a$groupTitle = _a.groupTitle,
      groupTitle = _a$groupTitle === void 0 ? '' : _a$groupTitle,
      _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$hasSeparator = _a.hasSeparator,
      hasSeparator = _a$hasSeparator === void 0 ? false : _a$hasSeparator,
      props = __rest(_a, ["className", 'aria-label', "groupTitle", "children", "hasSeparator"]);

  return React.createElement("section", Object.assign({}, props, {
    className: css(styles.optionsMenuGroup)
  }), groupTitle && React.createElement("h1", {
    className: css(styles.optionsMenuGroupTitle)
  }, groupTitle), React.createElement("ul", {
    className: className,
    "aria-label": ariaLabel
  }, children, hasSeparator && React.createElement(Divider, {
    component: "li",
    role: "separator"
  })));
};